// extracted by mini-css-extract-plugin
module.exports = {"sponsoredTip":"SponsoredTip_sponsoredTip__2VoP4","image":"SponsoredTip_image__1plX5","content":"SponsoredTip_content__2lFHs"};